import { flowExcelStore, setRuntimeFormInit } from '@/store/flowExcelStore';
export async function loadRuntimeConfig() {
  const response = await fetch('/settings/prod.json', {
    headers: {
      Accept: 'application/json'
    }
  });
  if (!response.ok) {
    throw new Error(`加载运行时配置失败: ${response.status}`);
  }

  // 并行拉 formInit.js —— 这是一个 ESM 模块脚本。
  // 用 fetch 拿到源码后，用 new Function 在隔离作用域执行，
  // 通过一个伪造的 exports 对象接收 export function formInit(...)。
  const formInitRes = await fetch('/js/formInit.js', {
    headers: {
      Accept: 'application/javascript, */*;q=0.8'
    }
  });
  if (!formInitRes.ok) {
    throw new Error(`加载 formInit.js 失败: ${formInitRes.status}`);
  }
  const formInitCode = await formInitRes.text();

  // 把源码里的 ESM `export function xxx` 改写成挂到 exports 的普通函数声明，
  // 这样 new Function（不支持 import/export）也能执行。
  // 同时剥掉 import 语句（运行时靠参数注入依赖）。
  const cleanedCode = formInitCode.replace(/^\s*;\s*$/gm, '') // 去掉空语句行（之前模板残留）
  // 只去掉行首 import；贪婪到行尾的分号避免误伤注释/字符串里的 ;
  .replace(/^\s*import\s+[^;\n]+;?\s*$/gm, '').replace(/^\s*export\s+function\s+(\w+)/gm, 'exports.$1 = function $1');

  // eslint-disable-next-line no-new-func
  const runner = new Function('exports', `${cleanedCode}\nreturn exports;`);
  const moduleExports = {};
  runner(moduleExports);
  if (typeof moduleExports.formInit !== 'function') {
    throw new Error('formInit.js 中未导出 formInit 函数');
  }

  // 注入到 flowExcelStore，业务侧（FlowCenterModal）通过 flowExcelStore.runtimeFormInit 调用
  setRuntimeFormInit(moduleExports.formInit);

  // eslint-disable-next-line no-console
  console.log('--------------------->formInit loaded', flowExcelStore.runtimeFormInit);
  return response.json();
}